import { render, staticRenderFns } from "./view-mapa-voluntarios.vue?vue&type=template&id=008d08e0&scoped=true"
import script from "./view-mapa-voluntarios.vue?vue&type=script&lang=js"
export * from "./view-mapa-voluntarios.vue?vue&type=script&lang=js"
import style0 from "./view-mapa-voluntarios.vue?vue&type=style&index=0&id=008d08e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008d08e0",
  null
  
)

export default component.exports